// src/form/report/pdf/transaksimanasuka.js
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// Format angka jadi Rupiah
const formatRupiah = (angka) => {
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 2,
  }).format(Number(angka));
};

// Konversi angka ke teks terbilang
const terbilang = (angka) => {
  const satuan = [
    "",
    "Satu",
    "Dua",
    "Tiga",
    "Empat",
    "Lima",
    "Enam",
    "Tujuh",
    "Delapan",
    "Sembilan",
    "Sepuluh",
    "Sebelas",
  ];
  angka = Math.floor(angka);

  if (angka < 12) return satuan[angka];
  if (angka < 20) return terbilang(angka - 10) + " Belas";
  if (angka < 100) return terbilang(Math.floor(angka / 10)) + " Puluh " + terbilang(angka % 10);
  if (angka < 200) return "Seratus " + terbilang(angka - 100);
  if (angka < 1000) return terbilang(Math.floor(angka / 100)) + " Ratus " + terbilang(angka % 100);
  if (angka < 2000) return "Seribu " + terbilang(angka - 1000);
  if (angka < 1000000) return terbilang(Math.floor(angka / 1000)) + " Ribu " + terbilang(angka % 1000);
  if (angka < 1000000000) return terbilang(Math.floor(angka / 1000000)) + " Juta " + terbilang(angka % 1000000);
  return "";
};

// === Fungsi Cetak PDF (tanpa API) ===
const TransaksiManasukapdf = (data) => {
  if (!data || data.length === 0) {
    alert("Tidak ada data untuk dicetak.");
    return;
  }

  const d = data[0]; // ambil transaksi pertama
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4"
  });

  // === Header ===
  doc.setFontSize(12);
  doc.text("KPRI SRI REJEKI", 14, 15);
  doc.text("4094/BH/II/78", 14, 21);
  doc.text("SIMPAN PINJAM", 14, 27);

  doc.setFontSize(14);
  doc.text("BKM", 105, 15, { align: "center" });
  doc.text("BUKTI KAS MASUK", 105, 22, { align: "center" });

  // Nomor transaksi & tanggal
  doc.setFontSize(11);
  doc.text(`No. Transaksi : ${d.notransaksi}`, 150, 15);

  const tgl = new Date(d.tgltransak).toLocaleDateString("id-ID", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  doc.text(`Tanggal       : ${tgl}`, 150, 22);

  doc.line(14, 32, 195, 32);

  // === Isi tabel ===
  const rows = [
    ["Diterima dari", `: ${d.nama}`],
    ["Banyaknya Uang", `: ${formatRupiah(d.kredit)}`],
    ["Terbilang", `: ${terbilang(d.kredit)} Rupiah`],
  ];

  autoTable(doc, {
    startY: 36,
    body: rows,
    theme: "plain",
    styles: { fontSize: 11, cellPadding: 2 },
    columnStyles: {
      0: { cellWidth: 50 },
      1: { cellWidth: 130 },
    },
  });

  // === Uraian ===
  const lastY = doc.lastAutoTable.finalY + 10;
  doc.text("Untuk pembayaran (Uraian)", 14, lastY);
  doc.rect(14, lastY + 2, 180, 15);
  //doc.rect(10, 10, 190, 140);
  doc.text("Setoran Simpanan Manasuka", 16, lastY + 10);

  // === Tanda tangan ===
  const ySign = lastY + 40;
  doc.text("Bendahara", 40, ySign);
  doc.text("Kasir", 100, ySign);
  doc.text("Penyetor", 160, ySign);

  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl, "_blank");

  // Simpan PDF
  //doc.save(`BKM_${d.notransaksi}.pdf`);
};

export default TransaksiManasukapdf;
